import type { PressableProps } from "react-native"

import React from "react"
import { Platform, Pressable } from "react-native"

import { StyleSheet } from "react-native"
import { COLORS } from "./theme"

const styles = StyleSheet.create({
  root: {
    backgroundColor: COLORS.$black,
    bottom: 0,
    cursor: Platform.OS === "web" ? "pointer" : undefined,
    left: 0,
    opacity: 0.3,
    position: "absolute",
    right: 0,
    top: 0,
  },
})

export function Backdrop({ style, ...rest }: PressableProps) {
  return (
    <Pressable
      importantForAccessibility={"no"}
      style={(state) => [
        styles.root,
        typeof style === "function" ? style(state) : style,
      ]}
      {...rest}
    />
  )
}
